module.exports = __webpack_public_path__ + "1b110dc54675d7a1b993ae0545e13c08.png";